import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { environment } from '../environments/environment';
import { HttpClientModule } from '@angular/common/http';
import { provideAuthResource, provideBaseServices, provideCacheInterceptor } from '@usheru-hff/shared/utils-providers';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { StripeModule } from 'stripe-angular';
import { BrandedPageUiBrandedTemplatesModule } from '@usheru-hff/branded-page/ui-branded-templates';
import { AuthenticationDomainModule } from '@usheru-hff/authentication/domain';
import { SharedUtilsTranslationModule } from '@usheru-hff/shared/utils-translation';
import {
  ShowtimeStreamingSubscribeComponent,
  FormSubscriptionComponent
} from '@usheru-hff/movie-detail/feature-subscribe';
import { SharedFeatureSocialLinksModule } from '@usheru-hff/shared/feature-social-links';
import { SharedUtilsModule, TemplatesService } from '@usheru-hff/shared/utils';
import { HffCommonUiUsheruLogoModule } from '@usheru-hff/hff-common/ui-usheru-logo';
import { SharedUtilsImageModule } from '@usheru-hff/shared/utils-image';

import { SocialFeedComponent } from '@usheru-hff/channel-social-updates/feature-social-feed';
import { DialogModule } from 'primeng/dialog';
import { providerRouteReuseStrategy } from '@usheru-hff/hff-common/util-routes';
import { ENVIRONMENT } from '@environment';

const stripekey = environment.stripe;
@NgModule({
  declarations: [],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    StripeModule.forRoot(stripekey),
    HttpClientModule,
    BrandedPageUiBrandedTemplatesModule,
    AuthenticationDomainModule,
    SharedUtilsTranslationModule,
    ShowtimeStreamingSubscribeComponent,
    FormSubscriptionComponent,
    SharedFeatureSocialLinksModule,
    SharedUtilsModule,
    HffCommonUiUsheruLogoModule,
    SharedUtilsImageModule,

    SocialFeedComponent,
    DialogModule
  ],
  providers: [
    {
      provide: ENVIRONMENT,
      useValue: environment
    },
    TemplatesService,
    provideAuthResource(environment),
    provideBaseServices(environment),
    provideCacheInterceptor(),
    providerRouteReuseStrategy()
  ],
  bootstrap: []
})
export class AppModule {}
